import { render } from "./ContactsPage.vue?vue&type=template&id=f60d0d00&scoped=true"
import script from "./ContactsPage.vue?vue&type=script&lang=js"
export * from "./ContactsPage.vue?vue&type=script&lang=js"

import "./ContactsPage.vue?vue&type=style&index=0&id=f60d0d00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60d0d00"]])

export default __exports__